const endosadosRoutes = [
  {
    path: "endosados",
    name: "endosados",
    component: () => import(/* webpackChunkName: "endosados-page" */ "@/modules/endosados/pages/EndosadosPage.vue"),
  },
];

export default endosadosRoutes;
